import http from '@/utils/ajax'
import { TRAVEL_INIT_SUCCESS, TRAVEL_INIT_FAIL, TRAVEL_INIT_LOADING } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {}
}

const getters = {

}

const mutations = {
  [TRAVEL_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [TRAVEL_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [TRAVEL_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  }
}

const actions = {
  async travelManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.travelManagement
    commit(TRAVEL_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TRAVEL_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(TRAVEL_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
